
//             <h1 style={headerStyle}>FAQS</h1>
//             <p style={{font: 'Lato'}}>Here you can find answers to our most frequently asked questions! If you still can't find an answer, please contact us directly. </p>
//             <Accordion sx={accordionStyle}>
//                 <AccordionSummary expandIcon={<ArrowDropDownIcon />}>
//                     <Typography  sx={accordionHeaderStyle}>WHAT IS WILD AT ART?</Typography>
//                 </AccordionSummary>
//                 <AccordionDetails>
//                     <Typography sx={accordianDetailsStyle}>
//                         Wild At Art is a creative studio where everyone is an artist and can let their creativity run wild! We offer a variety of paint classes by local artists, crafts, slime making, texture painting, paint pouring, and our most popular activity - splatter sessions, for all ages and skill levels. We also host private events and parties.
//                     </Typography>
//                 </AccordionDetails>
//             </Accordion>
//             <Accordion sx={accordionStyle}>
//                     <AccordionSummary>
//                         <Typography  sx={accordionHeaderStyle}>What services do you offer?</Typography>
//                     </AccordionSummary>
//                     <AccordionDetails>
//                         <Typography sx={accordianDetailsStyle}>
//                             Wild At Art is a creative studio where everyone is an artist and can let their creativity run wild! We offer a variety of paint classes by local artists, crafts, slime making, texture painting, paint pouring, and our most popular activity - splatter sessions, for all ages and skill levels. We also host private events and parties.
//                         </Typography>
//                     </AccordionDetails>
//             </Accordion>
//             <Accordion sx={accordionStyle}>
//                     <AccordionSummary>
//                         <Typography  sx={accordionHeaderStyle}>What is a splatter session?</Typography>
//                     </AccordionSummary>
//                     <AccordionDetails>
//                         <Typography sx={accordianDetailsStyle}>
//                             Wild At Art is a creative studio where everyone is an artist and can let their creativity run wild! We offer a variety of paint classes by local artists, crafts, slime making, texture painting, paint pouring, and our most popular activity - splatter sessions, for all ages and skill levels. We also host private events and parties.
//                         </Typography>
//                     </AccordionDetails>
//             </Accordion>
//             <Accordion sx={accordionStyle}>
//                     <AccordionSummary>
//                         <Typography  sx={accordionHeaderStyle}>Do you host parties & private events?</Typography>
//                     </AccordionSummary>
//                     <AccordionDetails>
//                         <Typography sx={accordianDetailsStyle}>
//                             Wild At Art is a creative studio where everyone is an artist and can let their creativity run wild! We offer a variety of paint classes by local artists, crafts, slime making, texture painting, paint pouring, and our most popular activity - splatter sessions, for all ages and skill levels. We also host private events and parties.
//                         </Typography>
//                     </AccordionDetails>
//             </Accordion>
//             <Accordion sx={accordionStyle}>
//                     <AccordionSummary>
//                         <Typography  sx={accordionHeaderStyle}>How many people can Wild at Art accomodate?</Typography>
//                     </AccordionSummary>
//                     <AccordionDetails>
//                         <Typography sx={accordianDetailsStyle}>
//                             Wild At Art is a creative studio where everyone is an artist and can let their creativity run wild! We offer a variety of paint classes by local artists, crafts, slime making, texture painting, paint pouring, and our most popular activity - splatter sessions, for all ages and skill levels. We also host private events and parties.
//                         </Typography>
//                     </AccordionDetails>
//             </Accordion>
//             <Accordion sx={accordionStyle}>
//                     <AccordionSummary>
//                         <Typography  sx={accordionHeaderStyle}>What types of painting do you offer?</Typography>
//                     </AccordionSummary>
//                     <AccordionDetails>
//                         <Typography sx={accordianDetailsStyle}>
//                             Wild At Art is a creative studio where everyone is an artist and can let their creativity run wild! We offer a variety of paint classes by local artists, crafts, slime making, texture painting, paint pouring, and our most popular activity - splatter sessions, for all ages and skill levels. We also host private events and parties.
//                         </Typography>
//                     </AccordionDetails>
//             </Accordion>
//             <Accordion sx={accordionStyle}>
//                     <AccordionSummary>
//                         <Typography  sx={accordionHeaderStyle}>What types of crafts do you offer?</Typography>
//                     </AccordionSummary>
//                     <AccordionDetails>
//                         <Typography sx={accordianDetailsStyle}>
//                             Wild At Art is a creative studio where everyone is an artist and can let their creativity run wild! We offer a variety of paint classes by local artists, crafts, slime making, texture painting, paint pouring, and our most popular activity - splatter sessions, for all ages and skill levels. We also host private events and parties.
//                         </Typography>
//                     </AccordionDetails>
//             </Accordion>
//             <Accordion sx={accordionStyle}>
//                     <AccordionSummary>
//                         <Typography  sx={accordionHeaderStyle}>What are your hours?</Typography>
//                     </AccordionSummary>
//                     <AccordionDetails>
//                         <Typography sx={accordianDetailsStyle}>
//                             Wild At Art is a creative studio where everyone is an artist and can let their creativity run wild! We offer a variety of paint classes by local artists, crafts, slime making, texture painting, paint pouring, and our most popular activity - splatter sessions, for all ages and skill levels. We also host private events and parties.
//                         </Typography>
//                     </AccordionDetails>


import React from 'react';
import { Container, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

function FAQ() {
    const questions = [
        { question: 'How can I book?', answer: 'Book by texting or calling 270-577-5067. After your booking is confirmed, a deposit is required. ' },
        { question: 'What upcoming events are you hosting?', answer: 'Be sure to checkout our Facebook page (linked at the bottom) for upcoming events like holiday crafts, painting classes, and more!' },
        { question: 'What are your hours?', answer: 'We have walk in hours Wednesday through Friday from 11am to 4pm & Saturday 11am to 2pm. We are open 7 days a week by appointment!' },
        { question: 'What types of services do you offer?', answer: 'We offer splatter paint sessions, painting classes, holiday events, arts and crafts, and private events.' },
        { question: 'What should I wear to my Splatter Session?', answer: 'Although we provide basic protective gear, we encourage painters to wear old clothes you dont mind getting paint on (because accidents happen!) ' },
        { question: 'What do Splatter Sessions include?', answer: 'All splatter sessions include paint, basic protective gear, a canvas, and 1 hour in the Wild Room. View our Splatter Sessions page for more details about our different packages. ' },
        { question: 'What are the age requirements?', answer: 'All ages are welcome! Painters 6 and under must be accompanied by an adult in the splatter room. ' },
        { question: 'Where can I learn more?', answer: 'You can learn more across our site, on our Facebook page, or by giving us a call!' },
    ];

    const headerStyle = {
        fontFamily: 'Oswald',
        fontWeight: '500',
    };

    const iconStyle = {
        color: '#000', // Adjust the color of the dropdown icon as needed
        cursor: 'pointer',
    };

    const accordionStyle = {
        backgroundColor: '#DFABED',
        borderRadius: '4px',
        marginBottom: '10px',
        minHeight: ['2px', '30px', '60px'],
    };

    return (
        <Container sx={{ textAlign: 'center' }}>
            <h1 style={headerStyle}>FAQS</h1>
            <p>Here you can find answers to our most frequently asked questions! If you still can't find an answer, please contact us. </p>
            <br/>
            {questions.map((item, index) => (
                <Accordion key={index} sx={accordionStyle}>
                    <AccordionSummary expandIcon={<ArrowDropDownIcon style={iconStyle} />}>
                        <Typography variant="h6" style={{ fontFamily: 'Oswald', fontWeight: '300' }}>
                            {item.question}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>{item.answer}</Typography>
                    </AccordionDetails>
                </Accordion>
            ))}
        </Container>
    );
}

export default FAQ;